/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BusinessPresence = {
  CommercialOffice: "commercial-office",
  HomeBased: "home-based",
  MixedPresence: "mixed-presence",
  MobileBusiness: "mobile-business",
  OnlineOnly: "online-only",
  RetailStorefront: "retail-storefront",
} as const;
export type BusinessPresence = ClosedEnum<typeof BusinessPresence>;

/** @internal */
export const BusinessPresence$inboundSchema: z.ZodNativeEnum<
  typeof BusinessPresence
> = z.nativeEnum(BusinessPresence);
/** @internal */
export const BusinessPresence$outboundSchema: z.ZodNativeEnum<
  typeof BusinessPresence
> = BusinessPresence$inboundSchema;
